// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Complete: MarkdocTagRegistration = {
  tag: 'complete',
  component: 'Complete',
  attributes: {
    title: {type: String, localize: true},
  },
};
